// @ts-nocheck
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { FocusGroup } from 'components/focus';
import { useSelector, useDispatch } from 'react-redux';
import { openExitDialog } from 'actions/exitDialog';

import appActions from 'common/support/applicationActions';
import { useFocusManager } from 'hooks/focus';
import { useRestoration } from 'hooks/restoration';

import NavItem from 'components/navigation/NavItem';
import styles from './LeftNav.module.scss';

// const RestorationStatus = {
//   RESTORED: 'restored',
//   STARTED: 'started',
//   UNRESTORED: 'unrestored',
// };
// const useLeftNavRestoration = (isReady, title = "LeftNav") => {
//   console.log("USE LEFT NAV RESTORATION")
//   const { restorationState, setRestorationState } = useRestoration(title);
//   const focusManager = useFocusManager();

//   const restoredFocusId = restorationState?.focusId;

//   const [restorationStatus, setRestorationStatus] = useState(
//     RestorationStatus.STARTED,
//   );

//   useEffect(() => {
//     if (isReady && restorationStatus === RestorationStatus.STARTED) {
//       if (
//         restoredFocusId &&
//         focusManager.getFocusableElement(restoredFocusId)
//       ) {
//         focusManager.setCurrentFocus(restoredFocusId);
//         setRestorationStatus(RestorationStatus.RESTORED);
//       } else {
//         setRestorationStatus(RestorationStatus.UNRESTORED);
//       }
//     }
//   }, [focusManager, isReady, restoredFocusId, restorationStatus]);

//   // update here
//   useEffect(() => {
//     const onFocusChangedListener = () => {
//       if (focusManager.isFocusAncestor(`left-nav-focusable-content`)) {
//         setRestorationState({
//           ...restorationState,
//           focusId: focusManager.currentFocusId,
//         });
//       }
//     };
//     focusManager.addFocusChangedListener(onFocusChangedListener);
//     return () => {
//       focusManager.removeFocusChangedListener(onFocusChangedListener);
//     };
//   }, [focusManager, restorationState, setRestorationState]);

//   return [restorationStatus];
// };

const LeftNav = () => {
  const focusManager = useFocusManager();
  const page = useSelector(state => state.pageView);
  const pageName = page?.page;
  const loading = useSelector(state => state.kitchenSink.loading);
  const menu = useSelector(state => state.kitchenSink.data.menu);
  const dispatch = useDispatch();

  const [activeIndex, setActiveIndex] = useState(0);
  const [expandedState, setExpandedState] = useState(true);
  const [focusIndex, setFocusIndex] = useState(null);
  const [visibleState, setVisibleState] = useState(true);
  const fullScreenPlayer = useSelector(state => state.hero.fullScreenPlayer);
  // Handles the initial focus setting logic
  // const hasFocusBeenInitialized = useRef(false);
  // const [restoredFocus] = useLeftNavRestoration(!loading);

  const { restorationState } = useRestoration('leftnav');

  useEffect(() => {
    const onFocusChangedListener = () => {
      if (focusManager.isFocusAncestor('left-nav-focusable-content')) {
        setExpandedState(true);
      } else {
        setExpandedState(false);
      }
    };

    focusManager.addFocusChangedListener(onFocusChangedListener);
    return () => {
      focusManager.removeFocusChangedListener(onFocusChangedListener);
    };
  }, [focusManager]);

  useEffect(() => {
    if (restorationState) {
      setActiveIndex(restorationState.activeIndex);
    } else {
      setActiveIndex(0);
    }
  }, [restorationState]);

  const findActiveIndex = (m, p) => {
    if (!!m && !!p) {
      const result = m.findIndex(item => {
        return (
          p.page.toLowerCase().includes(item.label.toLowerCase()) ||
          item.tag?.name?.toLowerCase() === p.type
        );
      });
      return result;
    }
    return -1;
  };

  useEffect(() => {
    // if page changes, focus on the page we are currently on
    setActiveIndex(findActiveIndex(menu, page));
  }, [page, menu]);

  useEffect(() => {
    if (!fullScreenPlayer) {
      // only applies to hero player
      setVisibleState(true);
    } else {
      setVisibleState(false);
    }
  }, [fullScreenPlayer]);

  const onActionOverride = action => {
    if (action === appActions.moveRight) {
      // navigate away from left nav
      focusManager.setCurrentFocus(
        `${pageName.toLowerCase()}-focusable-content`,
      );
    } else if (action === appActions.back) {
      dispatch(openExitDialog());
    }
  };

  const onFocusIndexChanged = newid => {
    setFocusIndex(newid);
  };

  // every time focus is sent to LeftNav, focus on the active page
  const onFocusSetOverrideFunction = () => {
    setExpandedState(true);
    return findActiveIndex(menu, page);
  };

  return (
    <div className={classNames('fixed-left', 'h-100')}>
      <div
        className={classNames(
          'fixed-left',
          'h-100',
          styles.navBackground,
          expandedState ? styles.expanded : styles.minimized,
          expandedState ? 'expanded' : 'minimized',
          visibleState ? 'visible' : 'd-none',
        )}
      />
      <div
        className={classNames(
          'fixed-left',
          'text-white',
          'h-100',
          styles.LeftNav,
          'd-flex flex-column justify-content-center align-items-center',
          expandedState ? styles.expanded : styles.minimized,
          expandedState ? 'expanded' : 'minimized',
          visibleState ? 'visible' : 'd-none',
        )}
      >
        {!!visibleState && (
          <FocusGroup
            horizontal={false}
            focusId="left-nav-focusable-content"
            onActionOverride={onActionOverride}
            onFocusSetOverride={onFocusSetOverrideFunction}
            onFocusIndexChanged={onFocusIndexChanged}
            className={classNames('w-100')}
          >
            {!loading &&
              !!menu &&
              menu.map((item, index) => (
                <NavItem
                  key={`nav-item-${item.tag ? item.tag.key : item.action}`}
                  class="nav-item"
                  item={item}
                  index={index}
                  pageName={pageName}
                  isActive={index === activeIndex}
                  isFocused={expandedState && index === focusIndex}
                  isExpanded={expandedState}
                />
              ))}
          </FocusGroup>
        )}
      </div>
    </div>
  );
};
LeftNav.propTypes = {};

LeftNav.defaultProps = {};
export default LeftNav;
